var map = {
	"./apfelstrudel.png": "7502",
	"./baristaart.jpg": "7804",
	"./bier.jpg": "a3b9",
	"./cafeamplatzallergielogo.png": "0cdf",
	"./cafeamplatzfruehstueck.png": "848b",
	"./cafeamplatzlogonew.png": "00a9",
	"./cafeamplatzoeffnungszeiten.png": "9c64",
	"./cafeamplatzoeffnungszeitentante.png": "765f",
	"./camparisoda.jpg": "4b00",
	"./coffeetogo.jpg": "58c0",
	"./coffeetogocreativeart.jpg": "f800",
	"./coffeetogoextrasmall.jpg": "6fa6",
	"./coffeetogomiddlesize.jpg": "4eb2",
	"./coffeetogosmall.jpg": "f5eb",
	"./eiernockel.png": "bf01",
	"./frittatensuppe.png": "8f13",
	"./fruehstueckextra.png": "a3aa",
	"./getraenke.jpg": "4a27",
	"./gulasch.png": "0fd0",
	"./heisseschokolade.jpg": "94ac",
	"./hummusteller.png": "d9aa",
	"./kaffee.jpg": "9b86",
	"./kaffeemaschine.jpg": "917c",
	"./kaiserschmarrn.png": "a01c",
	"./kalbsschnitzel.png": "1bcd",
	"./kartoffelsalat.png": "430f",
	"./lachsteller.png": "6b26",
	"./leichtesfruehstueck.png": "ffc4",
	"./milchschaum.jpg": "bf4d",
	"./mozartschnitte.jpg": "65a5",
	"./omlette.png": "1714",
	"./platzhalter.png": "5ce3",
	"./powerfruehstueck.png": "01ad",
	"./schinkenkaesetoast.png": "ce0a",
	"./schokotortevegan.jpg": "8b1b",
	"./schweinsschnitzel.png": "ddb0",
	"./tee.jpg": "3ccb",
	"./topfenstrudel.png": "8ce3",
	"./veganesfruehstueck.png": "533e",
	"./wein.jpg": "7c36",
	"./zwiebelrostbraten.png": "29b2"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "7584";